/* eslint-disable camelcase */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Style&IMG===================
import './style.scss';

// =================React Hooks==================
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';

// ==================Dependance===================
import {
  Backdrop,
  Box, Fade, Modal, Typography,
} from '@mui/material';

// =============Actions=====================
import { setOpenModalExportQuery } from '../../actions/menuButton';
import { setSaveQueryParams } from '../../actions/file';
import { setNewSlugQuery } from '../../actions/site';

// ==========static Style MOdal=============
const styleModal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  bgcolor: 'background.paper',
  border: '1px solid grey',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
};

function ModalExportQuery() {
  // ===============HOOKS===========
  const openModal = useSelector((state) => state.menuButton.openModalExportQuery);
  const networkName = useSelector((state) => state.network.networkName);
  const markerName = useSelector((state) => state.metadata.data.stationShortData.marker_long_name);
  const metadataMarkerString = useSelector(
    (state) => state.multipleMetadata.dataMultiple.modalMultipleMetadataString,
  );
  const fileMarkerString = useSelector((state) => state.files.markerFilesString);
  const queryParams = useSelector((state) => state.files.queryParams);
  const newSlugString = useSelector((state) => state.site.newSlugQuery);
  const dispatch = useDispatch();
  const location = useLocation();
  const routeParams = useParams();
  const rawSlug = routeParams.slug ?? routeParams['*'] ?? '';
  const decodedSlug = decodeURIComponent(rawSlug);
  // ============handler==============
  const handleCloseExportQueryModal = () => {
    dispatch(setOpenModalExportQuery(false));
  };

  const useExportQuery = () => {
    let pyglass_request = '';
    let newSlugQuery = '';
    if (location.pathname.includes('file')) {
      pyglass_request = 'pyglass files -u https://gnssdata-epos.oca.eu/GlassFramework/';
    }
    else if (location.pathname.includes('metadata_multiple')) {
      pyglass_request = 'pyglass stations -u https://gnssdata-epos.oca.eu/GlassFramework/';
    }

    // function pour extraire les paramètres
    const getParam = (paramName, prefix, commandFlag, replaceChars = /,/g) => {
      if (decodedSlug.includes(`${paramName}=`)) {
        const startpos = decodedSlug.indexOf(`${paramName}=`);
        let endpos = decodedSlug.length;
        const nextAmp = decodedSlug.indexOf('&', startpos);
        if (nextAmp !== -1) endpos = nextAmp;
        const paramValue = decodedSlug.substring(startpos + prefix, endpos);
        pyglass_request += ` ${commandFlag} ${paramValue.replace(replaceChars, ' ')}`;
      }
    };

    // Site
    if (decodedSlug.includes('site=')) {
      const startpos = decodedSlug.indexOf('site=');
      let endpos = decodedSlug.length;
      if (decodedSlug.indexOf('&', startpos) !== -1) {
        endpos = decodedSlug.indexOf('&', startpos);
      }
      const param = decodedSlug.substring(startpos + 5, endpos);
      pyglass_request += ` -sn ${param.replace(/,/g, ' ')}`;
    }
    // Marker
    if (decodedSlug.includes('marker=')) {
      if (location.pathname.includes('file')) {
        pyglass_request += ` -m ${fileMarkerString}`;
        newSlugQuery = [`marker=${fileMarkerString}`, ...decodedSlug.split('&').filter((p) => !p.startsWith('marker='))].join('&');
      }
      if (location.pathname.includes('metadata_multiple')) {
        pyglass_request += ` -m ${metadataMarkerString}`;
        newSlugQuery = [`marker=${metadataMarkerString}`, ...decodedSlug.split('&').filter((p) => !p.startsWith('marker='))].join('&');
      }
    }
    else {
      newSlugQuery = decodedSlug;
    }
    // getParam('marker', 'marker='.length, '-m');
    // Coordonnées géographiques
    getParam('minLat', 'minLat='.length, '-rsminlat');
    getParam('maxLat', 'maxLat='.length, '-rsmaxlat');
    getParam('minLon', 'minLon='.length, '-rsminlon');
    getParam('maxLon', 'maxLon='.length, '-rsmaxlon');

    // Cercle
    if (decodedSlug.includes('circle')) {
      pyglass_request += ' -cs';
      getParam('centerLat', 'centerLat='.length, '');
      getParam('centerLon', 'centerLon='.length, '');
      getParam('radius', 'radius='.length, '');
    }

    // Polygon
    getParam('polygon', 'polygon='.length, '-ps', /[!,]/g);

    // Altitude
    if (decodedSlug.includes('altitude=')) {
      const startpos = decodedSlug.indexOf('altitude=');
      let endpos = decodedSlug.length;
      if (decodedSlug.indexOf('&', startpos) !== -1) {
        endpos = decodedSlug.indexOf('&', startpos);
      }
      const param = decodedSlug.substring(startpos + 9, endpos);
      const posseparatedparam = param.indexOf(',');

      if (posseparatedparam !== -1) {
        if (param.indexOf(',') !== 0) {
          pyglass_request += ` -htmin ${param.substring(0, posseparatedparam)} -htmax ${param.substring(posseparatedparam + 1)}`;
        }
        else {
          pyglass_request += ` -htmax ${param.substring(1)}`;
        }
      }
      else {
        pyglass_request += ` -htmin ${param}`;
      }
    }

    if (decodedSlug.includes('longitude=')) {
      const startpos = decodedSlug.indexOf('longitude=');
      let endpos = decodedSlug.length;
      if (decodedSlug.indexOf('&', startpos) !== -1) {
        endpos = decodedSlug.indexOf('&', startpos);
      }
      const param = decodedSlug.substring(startpos + 10, endpos);
      const posseparatedparam = param.indexOf(',');

      if (posseparatedparam !== -1) {
        if (param.indexOf(',') !== 0) {
          pyglass_request += ` -lgmin ${param.substring(0, posseparatedparam)} -lgmax ${param.substring(posseparatedparam + 1)}`;
        }
        else {
          pyglass_request += ` -lgmax ${param.substring(1)}`;
        }
      }
      else {
        pyglass_request += ` -lgmin ${param}`;
      }
    }

    // Latitude
    if (decodedSlug.includes('latitude=')) {
      const startpos = decodedSlug.indexOf('latitude=');
      let endpos = decodedSlug.length;
      if (decodedSlug.indexOf('&', startpos) !== -1) {
        endpos = decodedSlug.indexOf('&', startpos);
      }
      const param = decodedSlug.substring(startpos + 9, endpos);
      const posseparatedparam = param.indexOf(',');

      if (posseparatedparam !== -1) {
        if (param.indexOf(',') !== 0) {
          pyglass_request += ` -ltmin ${param.substring(0, posseparatedparam)} -ltmax ${param.substring(posseparatedparam + 1)}`;
        }
        else {
          pyglass_request += ` -ltmax ${param.substring(1)}`;
        }
      }
      else {
        pyglass_request += ` -ltmin ${param}`;
      }
    }

    // Dates d'installation
    getParam('installedDateMin', 'installedDateMin='.length, '-idmin');
    getParam('installedDateMax', 'installedDateMax='.length, '-idmax');

    // Dates de suppression
    getParam('removedDateMin', 'removedDateMin='.length, '-rdmin');
    getParam('removedDateMax', 'removedDateMax='.length, '-rdmax');

    // Réseaux
    getParam('network', 'network='.length, '-nw');
    getParam('invertedNetworks', 'invertedNetworks='.length, '-inw');

    // Agence
    getParam('agency', 'agency='.length, '-ag');
    getParam('receiver', 'receiver='.length, '-rt');
    getParam('antenna', 'antenna='.length, '-at');
    getParam('radome', 'radome='.length, '-radt');
    getParam('country', 'country='.length, '-co');
    getParam('state', 'state='.length, '-pv');
    getParam('city', 'city='.length, '-ct');
    getParam('satelliteSystem', 'satelliteSystem='.length, '-ss');

    // DateRange
    if (decodedSlug.includes('dateRange=')) {
      const startpos = decodedSlug.indexOf('dateRange=');
      let endpos = decodedSlug.length;
      if (decodedSlug.indexOf('&', startpos) !== -1) {
        endpos = decodedSlug.indexOf('&', startpos);
      }
      const param = decodedSlug.substring(startpos + 10, endpos);
      const splitted = param.split(',');

      if (splitted.length === 2) {
        if (splitted[0] !== '') {
          pyglass_request += ` -dds ${splitted[0]}`;
        }
        if (splitted[1] !== '') {
          pyglass_request += ` -dde ${splitted[1]}`;
        }
      }
      else {
        pyglass_request += ` -dds ${param}`;
      }
    }

    // Data Availability
    getParam('dataAvailability', 'dataAvailability='.length, '-da');

    // File Type
    getParam('fileType', 'fileType='.length, '-ft');

    // Sampling Frequency
    getParam('samplingFrequency', 'samplingFrequency='.length, '-sf');

    // Sampling Window
    getParam('samplingWindow', 'samplingWindow='.length, '-sw');

    // Minimum Observation Years
    getParam('minimumObservationYears', 'minimumObservationYears='.length, '-mo');

    // Status File
    getParam('statusfile', 'statusfile='.length, '-stf');

    // Observation Type
    getParam('observationtype', 'observationtype='.length, '-obst');

    // Frequency
    getParam('frequency', 'frequency='.length, '-freq');

    // Constellation
    getParam('constellation', 'constellation='.length, '-constel');

    // Ratio Epoch
    getParam('ratioepoch', 'ratioepoch='.length, '-epoch');

    // Elevation Angle
    getParam('elevangle', 'elevangle='.length, '-elang');

    // Multipath Value
    getParam('multipathvalue', 'multipathvalue='.length, '-multpath');

    // Nombre de Cycle Slips
    getParam('nbcycleslips', 'nbcycleslips='.length, '-cycslps');

    // SPP RMS
    getParam('spprms', 'spprms='.length, '-ssprms');

    // Nombre de Clock Jumps
    getParam('nbclockjumps', 'nbclockjumps='.length, '-clkjmps');

    // Channel
    getParam('channel', 'channel='.length, '-chan');
    dispatch(setSaveQueryParams(pyglass_request));
    dispatch(setNewSlugQuery(newSlugQuery));
  };

  useEffect(() => {
    useExportQuery();
  }, [routeParams]);

  return (
    <Modal
      open={openModal}
      className="modalExportQuery"
      onClose={handleCloseExportQueryModal}
      aria-labelledby="modal-modal-title"
      arial-aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrops: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 600,
        },
      }}
    >
      <Fade in={openModal}>
        <Box sx={styleModal}>
          <Typography className="modalExportQuery--title">
            Request
          </Typography>
          <Box>
            <p>
              <b>API request :</b>
              {(location.pathname.includes('network/name=')) && (
                <a href={`https://gnssdata-epos.oca.eu/GlassFramework/webresources/stations/v2/combination/full/json?network=${networkName}`} rel="noreferrer" target="_blank"> https://gnssdata-epos.oca.eu/GlassFramework/webresources/stations/v2/combination/full/json?network={networkName}</a>
              )}
              {(location.pathname.includes('metadata/')) && (
                <a href={`https://gnssdata-epos.oca.eu/GlassFramework/webresources/stations/v2/combination/full/json?marker=${markerName}`} rel="noreferrer" target="_blank"> https://gnssdata-epos.oca.eu/GlassFramework/webresources/stations/v2/combination/full/json?marker={markerName}</a>
              )}
              {(location.pathname.includes('metadata_multiple/')) && (
                <a href={`https://gnssdata-epos.oca.eu/GlassFramework/webresources/stations/v2/combination/full/json?${newSlugString}`} rel="noreferrer" target="_blank"> https://gnssdata-epos.oca.eu/GlassFramework/webresources/stations/v2/combination/full/json?{newSlugString}</a>
              )}
              {(location.pathname.includes('file/')) && (
                <a href={`https://gnssdata-epos.oca.eu/GlassFramework/webresources/files/combination/${newSlugString}/json`} rel="noreferrer" target="_blank"> https://gnssdata-epos.oca.eu/GlassFramework/webresources/files/combination/{newSlugString}/json</a>
              )}
            </p>
            <p>
              <b>Command line request :</b>
              {(location.pathname.includes('network/name=')) && (
                <code> pyglass stations -u https://gnssdata-epos.oca.eu/GlassFramework/ -nw {networkName} -o full-json</code>
              )}
              {(location.pathname.includes('metadata/')) && (
                <code> pyglass stations -u https://gnssdata-epos.oca.eu/GlassFramework/ -m {markerName} -o full-json</code>
              )}
              {(location.pathname.includes('metadata_multiple/')) && (
                <code> {queryParams} -o full-json</code>
              )}
              {(location.pathname.includes('file/')) && (
                <code> {queryParams} -o full-json</code>
              )}
            </p>
            <div className="commandLineClient--modal__text--button">
              <button className="commandLineClient--modal__text--button__close" type="button" onClick={handleCloseExportQueryModal}>Close</button>
            </div>
          </Box>
        </Box>
      </Fade>

    </Modal>
  );
}

export default ModalExportQuery;
